import { AxiosError } from "axios";

/**
 * Extracts the server's actual error message from a failed request.
 * NestJS HttpExceptions send `message` as a string; ValidationPipe sends an
 * array of strings. Falls back to the axios/Error message, then the fallback.
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof AxiosError) {
    const message = error.response?.data?.message;
    if (Array.isArray(message)) return message.join(", ");
    if (typeof message === "string") return message;
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
